
export default {
  mensaje: "",
  colorDlg: "primary",
  titleDlg: "Aviso",
  showDialog: false
}

export function showInfo(mensaje) {
  return {
    mensaje,
    colorDlg: "primary",
    titleDlg: "Aviso",
    showDialog: true
  }
}

export function showWarning(mensaje) {
  return {
    mensaje,
    colorDlg: "accent",
    titleDlg: "Revisar",
    showDialog: true
  }
}

export function showError(mensaje) {
  return {
    mensaje,
    colorDlg: "error",
    titleDlg: "Error",
    showDialog: true
  }
}
